import './App.css';
import "bootstrap/dist/css/bootstrap.css"
import AdminRouter from './Routers';
import "./Assets/css/style.css";
import { Provider } from 'react-redux';
import store from './store';
// import { NotificationProvider } from './context/NotificationContext';
// import useFirebaseMessaging from './useFirebaseMessaging';

function App() {
  
  
  return (
    <Provider store={store}>
      <AdminRouter />

    </Provider>
  );
}

export default App;
